var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m487.055 457.473-29.582 29.582c-4.023 4.023-10.546 4.023-14.569 0l-19.206-19.206 44.151-44.151 19.206 19.206c4.023 4.023 4.023 10.546 0 14.569z",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 489.777v11.922c0 5.69-4.612 10.302-10.302 10.302h-11.922c-2.732 0-5.353-1.085-7.284-3.017l-23.473-23.473 26.491-26.491 23.473 23.473c1.932 1.931 3.017 4.551 3.017 7.284z",
    fill: "#4a80aa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.415,
    cy: 360.415,
    fill: "#dd636e",
    r: 124.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.934 260.961c15.95 20.973 25.424 47.138 25.424 75.519 0 68.968-55.91 124.878-124.878 124.878-28.381 0-54.546-9.474-75.519-25.424 22.809 29.992 58.867 49.359 99.454 49.359 68.968 0 124.878-55.91 124.878-124.878 0-40.587-19.368-76.645-49.359-99.454z",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.415,
    cy: 360.415,
    fill: "#e4f6ff",
    r: 91.577
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.717 287.422c11.66 15.367 18.584 34.525 18.584 55.302 0 50.577-41 91.577-91.577 91.577-20.777 0-39.935-6.924-55.302-18.584 16.723 22.039 43.194 36.275 72.993 36.275 50.577 0 91.577-41.001 91.577-91.577 0-29.799-14.237-56.27-36.275-72.993z",
    fill: "#d3effb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMusic);
export default __webpack_public_path__ + "static/media/searchMusic.590c91589805ae719edb01ad67fd71b2.svg";
export { ForwardRef as ReactComponent };